/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chess-knight-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M8.25 17.25V15c0-2.29 2.25-4.5 2.25-6"/><path pid="1" d="M17.25 17.25V9h0c0-2.9-2.35-5.25-5.25-5.26v0c0-2.25-1.75-3-3.75-3v3l-4 2.85h-.01c-.68.48-.83 1.41-.35 2.09l.02.02.68.907-.01-.01c.38.51 1.06.72 1.67.52l3.47-1.16h2.25"/><path pid="2" d="M20.923 21.533c-.29-.77-1.41-3.35-3.68-4.29h-9c-2.27.93-3.39 3.51-3.673 4.28h-.01c-.06.13-.08.27-.08.41v-.01c-.01.71.58 1.3 1.29 1.3h13.9l-.01-.001c.71 0 1.3-.59 1.3-1.3 0 0 0 0 0 0v-.01c0-.15-.03-.29-.08-.42z"/></g>'
  }
})
